import React from 'react'
import PropTypes from 'prop-types'
import { mergeProps } from 'src/util'
import styles from './PolynomialCoeff.scss'

const PolynomialCoeff = ({ sign, degree, children, ...domProps }) => (
  <span {...mergeProps()({ className: styles.coeff }, domProps)}>
    {sign && <span className={styles.sign}>{sign}</span>}
    {children}
    {degree > 0 && <span>x</span>}
    {degree > 1 && <span className={styles.degree}>{degree}</span>}
  </span>
)

PolynomialCoeff.propTypes = {
  sign: PropTypes.oneOf(['', '-', '+']),
  degree: PropTypes.number,
  children: PropTypes.node,
}

export default PolynomialCoeff
